module.exports = __webpack_public_path__ + "static/media/youtube_mobile.931e5ebe.svg";